RshopApp.$mount('.l-header');

let resizeTimer;

let lightGallerySettings = {
    autoplay: false,
    autoplayControls: false,
    thumbnail: false,
    download: false,
    share: false,
    fullScreen: false,
    videoMaxWidth: "1140px",
    iframeMaxWidth: "100%",
    enableDrag: true,
    enableTouch: true,
    zoom: false
};

const upsellSwiper = {
    promotionProducts: {
        slider: false,
        elem: $('.js-promotion-products-upsell'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 10,
            simulateTouch: false,
            roundLengths: true,
            navigation: {
                nextEl: '.js-promotion-products-upsell-next',
                prevEl: '.js-promotion-products-upsell-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                1199: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                767: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    slidesOffsetBefore: 42,
                    slidesOffsetAfter: 42,
                    freeMode: true
                },
                599: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 15,
                    slidesOffsetAfter: 15,
                    freeMode: true
                },
                359: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 12,
                    slidesOffsetAfter: 12,
                    freeMode: true
                },
            }
        }
    }
};

function freezeScroll() {
    const elementsToScroll = $('.js-allow-scroll, .modal');

    elementsToScroll.each(function(){
        const $elem = $(this);

        bodyScrollLock.disableBodyScroll($elem[0], {
            reserveScrollBarGap: true
        });
    });
}

function unfreezeScroll() {
    bodyScrollLock.clearAllBodyScrollLocks();

    setTimeout(function() {
        $('body').css('padding-right', '');
    }, 0)
}

$('.modal').on('show.bs.modal', function() {
    freezeScroll();
});

$('.modal').on('hidden.bs.modal', function() {
    unfreezeScroll();
});

function checkMedia(query) {
    let isVisible = false,
        breakPoints = query.split(',');

    $.each(breakPoints, function(key, breakPoint) {
        if (!isVisible) {
            isVisible = $('.c-var__item.' + breakPoint + '-is-visible').is(':visible');
        }
    });

    return isVisible;
}

function createStars($elem, options) {
    if ($elem.hasClass('.is-initialized')) {
        return false;
    }

    $elem.starRating($.extend({}, {
        starSize: 20,
        initialRating: $elem.attr('data-stars') * 5 / 100,
        readOnly: false,
        starShape: 'rounded',
        emptyColor: '#E0EBF5',
        activeColor: '#F8C81C',
        hoverColor: '#F8C81C',
        ratedColor: '#F8C81C',
        useGradient: false,
        disableAfterRate: false
    }, options));

    $elem.addClass('is-initialized');
}

$('.js-tabs-content').on('ruiTabShowed', function() {
    setTimeout(() => bLazy.revalidate(), 700);
});

Event.on('Cart.product.before_add', function(form) {
    $(form).find('.c-btn--cart').addClass('is-loading');
});

Event.on('Cart.product.after_add', function(response) {
    $(`.c-btn--cart.is-loading[data-ec-id="${response.item.product_id}"]`).removeClass('is-loading');
});

Event.on('Cart.upsell.show', function() {
    if (!$('.js-promotion-products-upsell').length) {
        return;
    }

    upsellSwiper.promotionProducts.elem = $('.js-promotion-products-upsell');
    upsellSwiper.promotionProducts.options.on = {
        init: function () {
            const swiperInstance = $('.js-promotion-products-upsell')[0].swiper;
            swiperInstance.slideTo(0, 0);
            swiperInstance.update();
        }
    };

    checkSwipers(upsellSwiper);
});

function setCountdown($element, time, format) {
    $element.countdown(time, function (event) {
        var totalHours = event.offset.totalDays * 24 + event.offset.hours;

        if (typeof format == 'undefined') {
            if (totalHours > 48) {
                format = '%D<span>d</span> : %H<span>h</span> : %M<span>m</span> : %S<span>s</span>';
            } else {
                format = `${totalHours}<span>h</span> : %M<span>m</span> : %S<span>s</span>`;
            }
        }

        $(this).html(event.strftime(format));
    })
}

$(function() {
    $(".l-content").on('click', '.pager__item', function () {
        const parents = $(this).parents('.listing');

        $(parents[parents.length - 1]).slideHere(30);
    });

    $(window).on('resize', function (e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
            Event.dispatch('Window.resized');
        }, 250);
    });

    $('body').on('shown.bs.modal', '#up-sell', function (e) {
        if (!$('.js-promotion-products-upsell').length) {
            return;
        }

        const swiperInstance = $('.js-promotion-products-upsell')[0].swiper;

        swiperInstance.slideTo(0, 0);
        swiperInstance.update();

        $('.js-stars').each(function() {
            createStars($(this), {
                readOnly: true,
                starSize: parseInt($(this).attr('data-size')) || 16
            });
        });

        setTimeout(function() {
            swiperInstance.slideTo(0, 0);
            swiperInstance.update();
        }, 100);
    });
});
